<template>
  <div>
    <Modal v-model="assignOrderModal.display" ref="assignOrderModal" title="选择接单人员" :loading="true" ok-text="指派清洁单" :width="900" @on-ok="surePreAssignOrder">
      <Form inline>
        <FormItem prop="keyword" label="姓名：" :label-width="84">
          <Input type="text" v-model="assignOrderModal.queryName"></Input>
        </FormItem>
        <FormItem prop="keyword" label="手机号：" :label-width="84">
          <Input type="text" v-model="assignOrderModal.queryMobile"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="queryWithKeyword">查询</Button>
        </FormItem>
      </Form>
      <Table stripe highlight-row ref="accountTable" :columns="columns" :data="assignOrderModal.data" :loading="assignOrderModal.loading" @on-current-change="changeSelectedAccount"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="assignOrderModal.totalPage" :current="page" :page-size="pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
    </Modal>
  </div>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";
export default {
  props: {
    assignOrderModal:{
      type:Object,
      default:function (){
        return {}
      }
    },
  },
  data() {
    return {
      columns: [
        {
          title: "手机号",
          key: "account",
          align: "center",
          width: 288
        },
        {
          title: "用户名",
          key: "userName",
          align: "center",
          width: 288
        },
        {
          title: "接单权限",
          align: "center",
          width: 288,
          render:(h, param)=>{
            let stat = param.row.accept==1? '已开通' : '未开通';
            return h('div', {}, stat)
          }
        }
      ],
      page: 1,
      pageSize: 10,
      count: 0,
      selectedAccount: '',
    };
  },
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  methods: {
    // 前端查询
    queryWithKeyword() {
      const params = {
        page:this.page,
        size:this.pageSize,
        userName:this.assignOrderModal.queryName,
        account:this.assignOrderModal.queryMobile
      }
      this.$emit('chooseCleaner',params)
    },
    changePage(pageIndex) {
      this.page = pageIndex;
      this.queryWithKeyword()
    },
    changePageSize(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.queryWithKeyword()
    },
    changeSelectedAccount(currAccount) {
      if(!currAccount) return;
      if(currAccount.accept == 1){
        this.selectedAccount = currAccount.account;
        this.$emit('changeSelected', this.selectedAccount);
      }else {
        this.$refs.accountTable.clearCurrentRow();
      }
    },
    async surePreAssignOrder() {
      if (!Utils.hasPermission('oms_xbclean_xbCleanOrder_assignOrder')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        this.$refs.assignOrderModal.buttonLoading = false;
        return
      }
      if (!this.selectedAccount) {
        this.$Notice.error({
          title: "请指定接单人员"
        });
        this.$refs.assignOrderModal.buttonLoading = false;
        return
      }
      const resp = (await API.omsAPI[this.env].cleaner.assignCleanOrder(this.assignOrderModal.id, this.selectedAccount, this.username, this.token)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "接单失败",
          desc: resp.msg
        });
        this.$refs.assignOrderModal.buttonLoading = false;
        return
      }
      this.$Notice.success({
        title: "接单成功"
      });
      this.selectedAccount = ''
      this.$emit('preAssignOrder')
    }
  }
};
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/pages/cleaner/order-list/account-table.vue